import React from 'react';
import ReactPlayer from 'react-player';
import { MediaProps, MediaType } from 'model/index';

import { Contract } from './Contract';

interface Props {
    media: MediaProps
}
export const Media: React.FC<Props> = (props) => {
    //console.log("Media", props.media);
    switch (props.media.mediaType) {
        case MediaType.Video:
            if (!props.media.url) return null;
            return (
                <div style={{ padding: 0, width: '100%', height: '100%'  }}>
                    <ReactPlayer
                        controls
                        src={props.media.url}
                        playing
                        width={'100%'}
                        height={'100%'} />
                </div>
            );
        case MediaType.Image:
            return (
                <div className="centered">
                    <img src={props.media.url}
                        style={{ pointerEvents: 'none' }}
                        className="responsive" />
                </div>
            );
        case MediaType.File:
            if (!props.media.url) return null;
            return (
                <div className="centered">
                    <iframe src={props.media.url} width="100%" height="100%" style={{ border: 0 }}></iframe>
                </div>
            );
        case MediaType.Contract:
            return (
                <Contract catalogId={props.media.item} title={props.media.title ?? ''} />
            );
        default:
        case MediaType.None:
            return <React.Fragment />;
    }
}
